class CarFinance {
  constructor(carFinance) {
    this.carFinance = document.getElementById(carFinance);
    this.currencyTitle = "AED";
    this.profitRate=3.5;
    this.tenure= 4;
    // this.currencyTitle = "AED ";
    this.init();
  }

  init() {
    if (this.carFinance) {
      this.profitRate = parseInt(this.carFinance.getAttribute("data-profitrate"));
      this.currencyTitle = this.carFinance?.getAttribute("data-currencytitle");
      this.tenure = parseInt(this.carFinance.getAttribute("data-tenure"));
      this.initjQueryElements();
      this.addNumberOnlyListener("#input_tenure");
      this.addNumberOnlyListener("#input_car_price");
      this.addNumberOnlyListener("#input_down_payment");
      this.addNumberOnlyListener("#input_insurance_amount");
      this.addNumberOnlyListener("#input_profit_rate");

      this.carFinance
        .querySelector("#reset-form")
        .addEventListener("click", () => this.resetFields());
      this.carFinance
        .querySelector("#submit-form")
        .addEventListener("click", () => this.calculateCarFinanceSubmitForm());
    }
  }

  initjQueryElements() {
    const pathname = window.location.href;
    
    

    this.clearFields();
  }

  addNumberOnlyListener(selector) {
    if (selector) {
      const element = this.carFinance.querySelector(selector);
      if (element) {
        element.addEventListener("input", () => this.numberOnly(element.id));
      } else {
        console.error(`Element with selector ${selector} not found.`);
      }
    }
  }

  numberOnly(id) {
    const element = document.getElementById(id);
    if (element) {
      element.value = element.value.replace(/[^0-9]/g, "");
    }
  }

  initSlider() {
    let maxVal = parseInt(
      $(this.carFinance).find("#profit_rate").attr("data-slider-max")
    );
    let minVal = parseInt(
      $(this.carFinance).find("#profit_rate").attr("data-slider-min")
    );
    let checkLang = document.querySelector("html").getAttribute('lang');


    let val = parseInt($(this.carFinance).find("#input_profit_rate").attr("data-slider-initialvalue"));

    let step = parseInt($(this.carFinance).find("#profit_rate").attr("data-slider-step"));

    $(this.carFinance)
      .find("#profit_rate")
      .slider({
        range: "min",
        value: val || 0,
        min: minVal|| 0,
        max: maxVal||85,
        step: step || 1,
        isRTL: checkLang === 'ar' ? true : false,
        slide: (event, ui) => {
          $(this.carFinance).find("#input_profit_rate").val(ui.value);
        },
      });
    

    let maxValTenure = parseInt($(this.carFinance).find("#tenure").attr("data-slider-max"));
    let minValTenure = parseInt($(this.carFinance).find("#tenure").attr("data-slider-min"));
    let valTenure = parseInt($(this.carFinance).find("#input_tenure").attr("data-slider-initialvalue"));
    let stepTenure = parseInt($(this.carFinance).find("#tenure").attr("data-slider-step"));

    $(this.carFinance)
      .find("#tenure")
      .slider({
        range: "min",
        value: valTenure|| 0,
        min: minValTenure|| 0,
        max: maxValTenure||75,
        step: stepTenure || 1,
        isRTL: checkLang === 'ar' ? true : false,
        slide: (event, ui) => {
          $(this.carFinance).find("#input_tenure").val(ui.value);
        },
      });
  }

  addRadioListeners() {
    $(this.carFinance)
      .find('[id$="radio-salary-transfer-yes"]')
      .click(() => {
        $(this.carFinance)
          .find('[id$="profit_rate"]')
          .text(this.profitRateYes + "%");
        this.calculateInstallment();
      });

    $(this.carFinance)
      .find('[id$="radio-salary-transfer-no"]')
      .click(() => {
        $(this.carFinance)
          .find('[id$="profit_rate"]')
          .text(this.profitRateNo + "%");
        this.calculateInstallment();
      });
  }

  clearFields() {
    $(this.carFinance)
      .find('[id$="total_finance_amount"]')
      .text(this.currencyTitle + "0");
    $(this.carFinance)
      .find('[id$="monthly_installment"]')
      .text(this.currencyTitle + "0");

    $(this.carFinance).find("#radio-salary-transfer-yes").prop("checked", true);
    $(this.carFinance).find("#radio-salary-transfer-no").prop("checked", false);

    $(this.carFinance).find("#input_car_price").val("");
    $(this.carFinance).find("#input_down_payment").val("");
    $(this.carFinance).find("#input_insurance_amount").val("");
    $(this.carFinance).find("#input_profit_rate").val("0");
    $(this.carFinance).find("#input_tenure").val("0");
    $(this.carFinance)
      .find("#answer")
      .text(this.currencyTitle + "0");

    this.initSlider();
    
    
  }

  calculateInstallment() {
    const propertyValue = parseFloat(
      $(this.carFinance).find("#property_value").val()
    );
    const percentFinance = parseFloat(
      $(this.carFinance).find("#percent_finance_input").val()
    );
    const tenure = parseFloat($(this.carFinance).find("#input_tenure").val());
    let profitRate = parseFloat(
      $(this.carFinance).find('[id$="profit_rate"]').text().replace("%", "")
    );

    const totalFinanceAmt = (propertyValue * percentFinance) / 100;
    if (!isNaN(totalFinanceAmt)) {
      $(this.carFinance)
        .find('[id$="total_finance_amount"]')
        .text(this.currencyTitle + totalFinanceAmt.toFixed(2));
    }

    if (tenure !== 0) {
      const monthlyInstallments = Math.round(
        (((totalFinanceAmt * (profitRate / 12)) / 100) *
          Math.pow(1 + profitRate / 12 / 100, tenure * 12)) /
          (Math.pow(1 + profitRate / 12 / 100, tenure * 12) - 1)
      );
      if (!isNaN(monthlyInstallments)) {
        $(this.carFinance)
          .find('[id$="monthly_installment"]')
          .text(this.currencyTitle + monthlyInstallments);
      }
    } else {
      $(this.carFinance)
        .find('[id$="monthly_installment"]')
        .text(this.currencyTitle + "0");
    }
  }

  calculateCarFinanceSubmitForm() {
    if (CalculateCarFinance) {
      CalculateCarFinance();
    }
  }

  resetFields() {
    $(this.carFinance).find("#input_car_price").val("");
    $(this.carFinance).find("#input_down_payment").val("");
    $(this.carFinance).find("#input_insurance_amount").val("");
    $(this.carFinance).find("#input_profit_rate").val("0");
    $(this.carFinance).find("#input_tenure").val("0");
    $(this.carFinance)
      .find("#answer")
      .text(this.currencyTitle + "0");
      this.initSlider();
  }
}

export default CarFinance;
